import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import moment from "moment";
import "moment-timezone";
import { BACKEND } from "../config/configEnvs";

import { FaBook, FaFileExcel } from "react-icons/fa";
// Imports para exportar en Excel
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { getToday } from "../utils/GetDates";
import LoadingScreen from "../components/ui/temp-screens/LoadingScreen";
import NoDataScreen from "../components/ui/temp-screens/NoDataScreen";
import PaginationItem from "../components/ui/components/Pagination";
import ExportarColeccionExcel from "../utils/automateFuncions/ExportarColeccionExcel";

function RegistrosAsistenciaAdmin() {
  
  const {start, end} = getToday()

  const [graceTime, setGraceTime] = useState(5)
  const [loading, setLoading] = useState(false);

  const [limit, setLimit] = useState(60);
  const [page, setPage] = useState(1);
  const [totalDocs, setTotalDocs] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [registers, setRegisters] = useState([]);
  const [workers, setWorkers] = useState([]);

  const [selectedWorker, setSelectedWorker] = useState("");
  const [reason, setReason] = useState("");
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);

  const diasMapeados = { // No se manejan tíldes en la BD, convertimos automáticamente los datos
    "lunes": "lunes",
    "martes": "martes",
    "miércoles": "miercoles",
    "jueves": "jueves",
    "viernes": "viernes",
    "sábado": "sabado",
    "domingo": "domingo"
  };

  const getRecord = async () => {
    try {
      setLoading(true)
      let url = `${BACKEND}/api/asistencias?page=${page}&limit=${limit}`
      const andFilters = []

      if (selectedWorker) {
        url += `&where[usuario][equals]=${selectedWorker}`
      }
      if (reason) {
        url += `&where[motivo][equals]=${reason}`
      }
      if (startDate) {
        const adjustedStartDate = new Date(startDate);
        adjustedStartDate.setHours(adjustedStartDate.getHours() + 5);
        andFilters.push({
          createdAt: {
            greater_than_equal: adjustedStartDate?.toISOString(),
          }
        })
      }
      if (endDate) {
        const adjustedEndDate = new Date(endDate);
        adjustedEndDate.setHours(adjustedEndDate.getHours() + 29);
        andFilters.push({
          createdAt: {
            less_than_equal: adjustedEndDate?.toISOString(),
          }
        })
      }
      if (andFilters.length > 0) {
        andFilters.forEach((filter, index) => {
          const key = `where[and][${index}][${Object.keys(filter)[0]}][${Object.keys(filter[Object.keys(filter)[0]])[0]}]`;
          const value = Object.values(Object.values(filter)[0])[0];
          url += `&${key}=${value}`;
        });
      }

      const response = await axios.get(url);
      setRegisters(response.data.docs);
      setTotalDocs(response.data.totalDocs);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  };

  const getWorkers = async () => {
    const response = await axios.get(`${BACKEND}/api/metaDataUsers/getWorkersData`)
    setWorkers(response.data.workers)
  }

  useEffect(() => {
    getRecord();
    getWorkers();
  }, []);

  useEffect(() => {
    getRecord();
  }, [page, limit, selectedWorker, reason, startDate, endDate]);


  function isTardanza(registro) {

    // Se usa esta función ya que no manejamos tíldes en la BD, 
    function obtenerDiaDeLaSemana(fecha) {
      const diaConTilde = moment(fecha).format("dddd").toLowerCase();
      return diasMapeados[diaConTilde] || diaConTilde;
    }
    
    // Hora a la que se marcó el registro en el sistema
    const horaRegistro = moment(registro.fecha).tz("America/Lima"); 
  
    // Día el que se marcó el registro en el sistema
    const diaDeLaSemana = obtenerDiaDeLaSemana(registro.fecha);

    // Miramos el horario del usuario
    const horarioUsuario = registro.usuario?.horarios?.find(horario => horario.dia === diaDeLaSemana);

    if (!horarioUsuario) { // Si no hay horario, el trabajador no trabaja ese día
      return false;
    }
    
    const horaEntradaEstandar = moment(registro.fecha) // Hora de entrada estándar del trabajador
      .tz("America/Lima")
      .set({
        hour: parseInt(horarioUsuario.horaEntrada.split(":")[0]),
        minute: parseInt(horarioUsuario.horaEntrada.split(":")[1]),
        second: 0
      });

    const tiempoLimite = moment(horaEntradaEstandar).add(graceTime, "minutes");// Tiempo límite con tolerancia

    const isTardanza = registro.motivo === "Entrada Trabajo" && horaRegistro.isAfter(tiempoLimite);

    return isTardanza;
  }

  function isHorasExtra(registro) {

    function obtenerDiaDeLaSemana(fecha) {
      const diaConTilde = moment(fecha).format("dddd").toLowerCase();
      return diasMapeados[diaConTilde] || diaConTilde;
    }
  
    const horaRegistro = moment(registro.fecha).tz("America/Lima")

    const diaDeLaSemana = obtenerDiaDeLaSemana(registro.fecha);

    const horarioUsuario = registro.usuario?.horarios?.find(horario => horario.dia === diaDeLaSemana)

    if (!horarioUsuario) {
      return false
    }

    const horaSalidaEstandar = moment(registro.fecha)
    .tz("America/Lima")
    .set({
      hour: parseInt(horarioUsuario.horaSalida.split(":")[0]),
      minute: parseInt(horarioUsuario.horaSalida.split(":")[1]),
      second: 0
    })

    const tiempoExtra = moment(horaSalidaEstandar).add(10, "minutes");// Tiempo límite con tolerancia

    const isHorasExtra = registro.motivo === "Salida Trabajo" && horaRegistro.isAfter(tiempoExtra)


    return isHorasExtra
  }

  const handlePageChange = (event, value) => { // Cambiar la página
    setPage(value)
  }

  const colorMap = {
    "Entrada Trabajo": "text-green-500",
    "Salida Almuerzo": "text-yellow-500",
    "Entrada Almuerzo": "text-blue-500",
    "Salida Trabajo": "text-red-500"
  }




  return (
    <div className="w-full flex flex-col h-screen">
      
      {/* NavBar */}
      <div className="flex flex-row items-center justify-center px-4 py-2 bg-gray-100">
        <div className="flex flex-row w-full items-center gap-4 justify-between overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          <div className="flex flex-row justify-start">
            <div className="flex items-center gap-4 p-4">
            <FaBook className="text-gray-700 text-2xl" />
              <h2 className="text-2xl font-bold text-gray-700">Historial de registros de asistencias</h2>
            </div>
          </div>

          <div className="flex flex-row gap-4 items-center justify-center">

            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Límite:</span>
              <select
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="60">60</option>
              </select>
            </div>


            <div className="flex flex-row text-xs text-gray-700 items-center justify-center gap-4">
              <span>Trabajador:</span>
              <select
                id="filtroFechaInicio"
                name="filtroFechaInicio"
                value={selectedWorker}
                onChange={(e) => setSelectedWorker(e.target.value)}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px] pr-10"
              >
                <option value="">Todos</option>
                {workers.map((worker) => (
                  <option
                    key={worker.id}
                    value={worker.id}
                  >
                    {worker.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

        </div>
      </div>

      {/* Barra de filtros */}
      <div className="flex bg-gray-100 mt-0.5 mb-0.5 items-center justify-center w-full gap-10">
        <div className="flex flex-row items-center w-full overflow-x-auto gap-4 px-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">

          <div className="flex flex-row w-full items-center justify-center gap-8">

            <div className="flex flec-row items-center justify-center gap-2">
              <label className="block text-xs font-medium text-gray-900">
                Fecha inicio
              </label>

              <div className="flex flex-row items-center justify-center gap-4">
                <input 
                  type="date" 
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                  value={new Date(startDate).toISOString().split('T')[0]}
                  onChange={(e) => setStartDate(new Date(e.target.value).toISOString())}
                />
              </div> 
            </div>

            <div className="flex flec-row items-center justify-center gap-2">
              <label className="block text-xs font-medium text-gray-900">
                Fecha fin
              </label>

              <div className="flex flex-row items-center justify-center gap-4">
                <input 
                  type="date" 
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                  value={new Date(endDate).toISOString().split('T')[0]}
                  onChange={(e) => setEndDate(new Date(e.target.value).toISOString())}
                />
              </div> 
            </div>

            
            <div className="flex flec-row items-center justify-center gap-2">
              <label className="block text-xs font-medium text-gray-900">
                Motivo
              </label>

              <div className="flex flex-row items-center justify-center gap-4">
                <select 
                  className="text-gray-700 hover:cursor-pointer text-xs bg-white border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                >
                  <option value="">Todos</option>
                  <option value="Entrada Trabajo">Entrada Trabajo</option>
                  <option value="Salida Almuerzo">Salida Almuerzo</option>
                  <option value="Entrada Almuerzo">Entrada Almuerzo</option>
                  <option value="Salida Trabajo">Salida Trabajo</option>
                </select>
              </div> 
            </div>
          </div>

        </div>
      </div>
      
      {/* Body */}
      <div className="flex-grow overflow-y-auto">
        {loading ? (
            <LoadingScreen />
          ) : (
            registers.length == 0 ? (
              <NoDataScreen />
            ) : (
              <table className="w-full">
                <thead className="bg-white sticky top-0">
                  <tr className="text-gray-700 text-center text-[10px] font-bold">
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Trabajador
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Motivo
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Fecha y hora
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Dirección IP
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      OS
                    </th>
                    <th className="px-2 py-3 text-center bg-[#FE6400] border-r border-r-white text-white border-red">
                      Navegador
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {registers.map((r, index) => {
                    return (
                      <tr key={r.id} className="text-xs py-3 w-full hover:bg-gray-100 transition-all duration-100">
                      
                        <td scope="row" className="px-4 py-3  text-center whitespace-nowrap border border-gray-300">
                          {r.usuario?.name}
                        </td>
                        <td scope="row" className={`px-4 font-bold py-3 text-center whitespace-nowrap border border-gray-300 ${colorMap[r.motivo]}`}>
                          {r.motivo}
                        </td>
                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <div className="flex flex-row items-center justify-center gap-2">
                            <span className="flex items-center justify-center">
                              {moment(r.fecha).tz("America/Lima").format("DD/MM/YYYY HH:mm")}
                            </span>
                            {isTardanza(r) && <span className="px-2 bg-red-500 text-white rounded-lg font-bold">Tardanza</span>}
                            {isHorasExtra(r) && <span className="px-2 bg-blue-500 text-white rounded-lg font-bold">Horas Extra</span>}
                          </div>
                        </td>
                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {r.direccion_ip}
                          </span>
                        </td>
                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {r.sistema_operativo}
                          </span>
                        </td>
                        <td scope="row" className="px-4 py-3 text-center whitespace-nowrap border border-gray-300">
                          <span className="flex items-center justify-center">
                            {r.navegador}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )
          )
        }
      </div>

      {/* Paginador */}
      <PaginationItem
        actualDocs={registers.length}
        totalDocs={totalDocs}
        entity="registros"
        totalPages={totalPages}
        actualPage={page}
        handlePageChange={handlePageChange}
      />

    </div>
  );
}

export default RegistrosAsistenciaAdmin;
